import { render, staticRenderFns } from "./fallible.vue?vue&type=template&id=ec9bae94&scoped=true"
import script from "./fallible.vue?vue&type=script&lang=js"
export * from "./fallible.vue?vue&type=script&lang=js"
import style0 from "./fallible.vue?vue&type=style&index=0&id=ec9bae94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9bae94",
  null
  
)

export default component.exports